import React from "react";
import { useSelector } from "react-redux";
import LandingNoPay from "../../components/schedaCliente/landingNoPay";
import Page from "../../components/general/page";

const LandingNoTSPay = props => {
  const { pageRef } = props;
  const myType = useSelector(state => state.main.myType);

  return (
    <Page pageRef={pageRef} activePage={"/scheda-cliente"} noHeaderContent noClassName>
      <div className={"contentStructure"}>
        {myType === "STUDIO" ? (
          <LandingNoPay  />
        ) : null}
      </div>
    </Page>
  );
};

export default LandingNoTSPay;
